import React, {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';

import { Doughnut, Bar, Line } from 'react-chartjs-2';

import {OzUserTag, OzButton, OzContainer, OzRow, OzCol, OzCard, OzTable, BORDER, OzDatepicker,  CHETWODEBLUE, OzSelect, OzProjectTag} from '@ozwol/webui';


import UsersService from '../../services/UsersService';
import ProjectsService from '../../services/ProjectsService';
import UsagesService from '../../services/UsagesService';

import Filters from '../../components/Filters';
import Meta from '../../components/Meta';
import PageHeader from '../../components/PageHeader';
import HealthyWrapper from '../../components/HealthyWrapper';
import CardHeaderTitle from '../../components/CardHeaderTitle';
import ChartWrapper from '../../components/ChartWrapper';

import {getChartOptions, getArrayOfDayHours, getArrayFromInterval, formatError, getFormattedDate, getFormattedTime, changeDate, getIsoDate, convertNumber, getWeekOfYear, getDayOfYear, convertSize, generateDistinctColors} from './../../helpers';

const RANGE_TODAY = "Today";
const RANGE_YESTERDAY = "Yesterday";
const RANGE_WEEK = "Weekly";
const RANGE_MONTH = "Monthly";
const RANGE_SEMESTER = "Six-Monthly";
const RANGE_YEAR = "Yearly";
const RANGE_CUSTOM = "Custom";

const SUBJECT_CREDITS = "credits";
const SUBJECT_METRICS = "assets";

const USAGES_UUID_COLUMN = 0;
const USAGES_INDEX_COLUMN = 1;
const USAGES_ASSETS_COLUMN = 2;
const USAGES_CREDITS_COLUMN = 3;
const USAGES_STORAGE_COLUMN = 4;
const USAGES_TRANSFER_COLUMN = 5;

const GRAIN_HOURS = "h";
const GRAIN_DAYS = "d";
// const GRAIN_WEEKS = "w";
const GRAIN_MONTHS = "M";

const CONSUMER_ALL = null;
const CONSUMER_SCRIPTS = "SCRIPT";
const CONSUMER_STORAGE = "STORAGE";
const CONSUMER_TRANSFER = "TRANSFER";

const GRAIN_TRANSLATIONS = {
  "h": "hour",
  "d": "day",
  "w": "week",
  "M": "month"
}

// const CardGroup = styled.div`
//   &>*:not(:first-child){
//     border-top-left-radius: 0px;
//     border-top-right-radius: 0px;
//     border-top: 3px solid ${GHOSTWHITE};
//   }
//   &>*:not(:last-child){
//     border-bottom-left-radius: 0px;
//     border-bottom-right-radius: 0px;
//   }
// `;


// const Header = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 40px;
//   margin-bottom: 40px;
// `;


const CardPhrase = styled.div`

  display: flex;
  align-items: center;
`;

const CardPhraseText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;

  display: flex;
  align-items: baseline;
`;
const CardPhraseSuperNumber = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #303030;
  margin: 0px 5px;
`;


const ButtonsGroup = styled.div`
  display: flex;
  & > :not(:first-child){
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  & > :not(:last-child){
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: 0px;
  }
  & :first-child > button{ //picker
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: 0px;
  }
`;
const ProjectTag = styled.div`
  display: flex;
  align-items: center;
`;
const Color = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: ${props => props.color};
  border-radius: 3px;
  border: 1px solid ${BORDER};
  margin-right: 8px;
`;

const ButtonIcon = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px;
  & > span{
    font-size: 20px;
  }
`;

const AverageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AverageLeft = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 10px;

  display: flex;
  align-items: center;
`;
const AverageRight = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  text-align: right;
  margin-left: 10px;
  display: flex;
  justify-content: flex-end;
`;
const AverageIcon = styled.div`
  margin-bottom: -5px;
  margin-right: 5px;
`;
const AverageBlock = styled.div`
  text-align: center;
  padding-left: 30px;
  margin-left: 30px;
  border-left: 1px solid #707070;
`;
const AverageLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  margin-bottom: 2px;
`;
const AverageValue = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #303030;
`;

const InsiderOverview = ({refScrollerPage}) => {
  let navigate = useNavigate();
  const [start, setStart] = useState(getIsoDate(new Date((new Date()).setUTCHours(0, 0, 0, 0))));
  const [end, setEnd] = useState(null);
  const [consumer, setConsumer] = useState(CONSUMER_SCRIPTS);
  const [hideTrivial, setHideTrivial] = useState(true);
  const [range, setRange] = useState(RANGE_TODAY);
  const [subject, setSubject] = useState(SUBJECT_METRICS);
  const [grain, setGrain] = useState(GRAIN_HOURS);
  const [projects, setProjects] = useState([]);
  const [usages, setUsages] = useState(null);
  const [users, setUsers] = useState([]);
  
  const [usagesLine, setUsagesLine] = useState(null);
  const [usagesBar, setUsagesBar] = useState(null);
  const [usagesDoughnut, setUsagesDoughnut] = useState(null);

  const [fetchError, setFetchError] = useState(false);

  
  const [averageYear, setAverageYear] = useState(null);
  
  const [selected, setSelected] = useState([]);

  // const scrollToCredits = useRef();
	const [filterSearchUsers, setFilterSearchUsers] = useState([]);

	/* v cerca progetti v */
	const DEFAULT_FILTERS = {
		"search": "",
		"userUuid": null
	};
	const [filters, setFilters] = useState(
		localStorage.getItem("ozwolConsoleFilterInsiderProjects"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))) ? 
			JSON.parse(localStorage.getItem("ozwolConsoleFilterInsiderProjects"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))))
		: 
			DEFAULT_FILTERS
		);
	const [filtersSearch, setFiltersSearch] = useState({
		"userUuid": ""
	});

	const changeFilters = useCallback((name, value) => {
		let tempFilters = {...filters};
		tempFilters[name] = value;
		setFilters(tempFilters);
	}, [filters]);

	const searchFilters = useCallback((name, value) => {
    let tempFiltersSearch = {...filtersSearch};
    tempFiltersSearch[name] = value;
    setFiltersSearch(tempFiltersSearch);


    if(value.length > 2 || value.length === 0){
      switch(name){
        case "userUuid":
          UsersService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response) => {
            setFilterSearchUsers(response.result);
          });
          break;
        default:
          break;
      }
    }

  }, [filtersSearch]);	

  useEffect(() => {
    UsersService.adminList().then((response) => {
      setFilterSearchUsers(response.result);
    });
  }, []);
	/* ^ cerca progetti ^ */

  useEffect(() => {
    ProjectsService.adminList({
      "search": filters.search.length > 2 ? filters.search : "",
      "userUuid": filters.userUuid,
			"limit": 0
    }).then((response) => {
      let colors = generateDistinctColors(response.length);
      setProjects(response.map((res,i) => ({...res, color: colors[i]})));     
      setSelected(response.map((project => project.uuid)));
    }).catch((error) => {
      setFetchError(formatError(error));
    }); 
    UsersService.adminList({"limit": 0}).then((response) => {
      setUsers(response.result);
    }).catch((error) => {
      setFetchError(formatError(error));
    }); 
    
    
  }, [filters]);

  useEffect(() => {
    let today = new Date();
    let params = {};
    params.consumer = CONSUMER_ALL;
    params.hideTrivial = true;
    
    params.grain = GRAIN_DAYS;
    params.start = today.getFullYear()+"-01-01T00:00:00";

    if(usages){
      let avgYear = usages.dataset.filter(set => selected.includes(set[USAGES_UUID_COLUMN])).reduce((accumulator, currentValue) => {
        return accumulator + currentValue[USAGES_ASSETS_COLUMN]
      },0);
      setAverageYear(avgYear);      
    }
    
    
  }, [usages, setAverageYear, selected]);

  useEffect(() => {   
    let params = {};
    params.grain = grain;
    params.start = start;
    params.consumer = consumer;
    params.hideTrivial = hideTrivial;
    params.end = end;
    UsagesService.listByProjects(params).then((response) => {
      setUsages(response);      
    }).catch((error) => {
      setFetchError(formatError(error));
    }); 
    
  }, [start, end, grain, consumer, hideTrivial]);

  useEffect(() => {
    if(projects && usages){
      let selectedProjects = projects.filter((project) => selected.includes(project.uuid));
      setUsagesDoughnut({
        datasets: [{
          labels: selectedProjects.map((item) => item.name),
          data: selectedProjects.map((project) => 
            usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
              return accumulator + currentValue[getColumn(subject, consumer)]
            },0)
          ),
          borderWidth: 1,
          backgroundColor: selectedProjects.map((item) => item.color),
        }]
      });

      if(grain === GRAIN_HOURS){
        setUsagesBar({
          labels: getArrayOfDayHours().map(item => getFormattedTime(item).slice(0,2)),
          datasets: selectedProjects.map((project) => ({
            label: project.name,
            // data: getArrayOfDayHours().map(hour => 
            data: getArrayOfDayHours().map(item => getFormattedTime(item).slice(0,2)).map(hour => 
              usages.dataset.filter(set => getFormattedTime(set[USAGES_INDEX_COLUMN]).slice(0,2) === hour && set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                return accumulator + currentValue[getColumn(subject, consumer)]
              },0)
            ),
            backgroundColor: project.color,
            tension: 0.1,
          }))
        });
      }else{
        setUsagesLine({
          labels: getArrayFromInterval(start, end ? end : new Date(), grain).map(day => 
						grain === GRAIN_MONTHS ? 
							getFormattedDate(day).slice(0,-2)
						:
							getFormattedDate(day)
					),
          // labels: [...new Set(usages.dataset.map(set => getFormattedDate(set[USAGES_INDEX_COLUMN], false) + " " + getWeekDay(set[USAGES_INDEX_COLUMN]).substring(0,3)))],
          datasets: [
            {
              data: getArrayFromInterval(start, end ? end : new Date(), grain).map(day => 
              // data: [...new Set(usages.dataset.map(set => set[USAGES_INDEX_COLUMN]))].map(day =>   
                usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day && selected.includes(set[USAGES_UUID_COLUMN])).reduce((accumulator, currentValue) => {
                  return accumulator + currentValue[getColumn(subject, consumer)]
                },0)
              ),
              borderColor: CHETWODEBLUE,
              tension: 0.1
            }
          ]
        });
      }
    }
    
  }, [subject, projects, usages, grain, consumer, start, end, selected]);

  const getColumn = (subject, consumer) => {
    if(subject === SUBJECT_CREDITS){
      return USAGES_CREDITS_COLUMN;
    }else if(consumer === CONSUMER_SCRIPTS || consumer === CONSUMER_ALL){
      return USAGES_ASSETS_COLUMN;
    }else if(consumer === CONSUMER_STORAGE){
      return USAGES_STORAGE_COLUMN;
    }else if(consumer === CONSUMER_TRANSFER){
      return USAGES_TRANSFER_COLUMN;
    }
  }

  return (
    <OzContainer size="extra">
      <Meta title={"Overview"} />
      <PageHeader
        breadcrumbsIcon="mountain_flag"
        breadcrumbsText={["Overview"]}
        refScrollerPage={refScrollerPage}
      />
      <HealthyWrapper error={fetchError} loading={!projects || !users}>
        <OzRow>
          <OzCol widthmd={8}>
            <ButtonsGroup>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={consumer === CONSUMER_ALL}
                onClick={() => {
                  setConsumer(CONSUMER_ALL);
                  setSubject(SUBJECT_CREDITS);
                }}
                noMinWidth
              >
                All
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={consumer === CONSUMER_SCRIPTS}
                onClick={() => {
                  setConsumer(CONSUMER_SCRIPTS);
                }}
                noMinWidth
              >
                Scripts
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={consumer === CONSUMER_STORAGE}
                onClick={() => {
                  setConsumer(CONSUMER_STORAGE);
                }}
                noMinWidth
              >
                Storage
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={consumer === CONSUMER_TRANSFER}
                onClick={() => {
                  setConsumer(CONSUMER_TRANSFER);
                }}
                noMinWidth
              >
                Transfer
              </OzButton>
            </ButtonsGroup>
          </OzCol>
          
          {/* <OzCol widthmd={3}>
            <OzSelect
              width="100%"
              values={[{
                "name": <b>Hours</b>,
                "value": GRAIN_HOURS,
              },{
                "name": <b>Days</b>,
                "value": GRAIN_DAYS,
              },{
                "name": <b>Weeks</b>,
                "value": GRAIN_WEEKS,
              },{
                "name": <b>Months</b>,
                "value": GRAIN_MONTHS,
              }]}
              selected={grain}
              onChange={(val) => {
                setGrain(val);
              }}
            />
          </OzCol>         */}
          <OzCol widthmd={4}>
            <OzSelect
              width="100%"
              values={[{
                "name": <b>Hide trivial</b>,
                "value": true,
              },{
                "name": <b>Show trivial</b>,
                "value": false,
              }]}
              selected={hideTrivial}
              onChange={(val) => {
                setHideTrivial(val);
              }}
            />
          </OzCol>
          <OzCol widthmd={4}> 
            <ButtonsGroup>
              {consumer !== CONSUMER_ALL ? 
                <OzButton
                  width="100%"
                  variant={"push-black"}
                  pushed={subject === SUBJECT_METRICS}
                  onClick={() => setSubject(SUBJECT_METRICS)}
                  noMinWidth
                >
                  {consumer === CONSUMER_STORAGE ? 
                    "Storage"
                  : consumer === CONSUMER_TRANSFER ? 
                    "Transfer"
                  : "Assets"}
                </OzButton>
              : null}
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={subject === SUBJECT_CREDITS}
                onClick={() => setSubject(SUBJECT_CREDITS)}
                noMinWidth
              >
                Credits
              </OzButton>
            </ButtonsGroup>
          </OzCol>
          <OzCol widthmd={8}>
            <ButtonsGroup>
              <OzDatepicker
                type="range"
                compact={true}
                buttonLabel={<span className="material-symbols-outlined">calendar_month</span>}
                onChange={(startVal, endVal) => {
                  startVal = new Date(new Date(startVal).toDateString());
                  startVal = new Date(Date.UTC(startVal.getFullYear(), startVal.getMonth(), startVal.getDate(), 0, 0, 0));
                  setStart(getIsoDate(startVal));

                  if(endVal){
                    endVal = new Date(new Date(endVal).toDateString());
                    endVal = new Date(Date.UTC(endVal.getFullYear(), endVal.getMonth(), endVal.getDate(), 23, 59, 59));
                    setEnd(getIsoDate(endVal));
                  }

                  setRange(RANGE_CUSTOM);
                  setGrain(GRAIN_DAYS);

                }}
                startValue={new Date((new Date(start)).setHours(0, 0, 0, 0))}
                endValue={new Date((new Date(end)).setHours(23, 59, 59, 999))}
              />
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_YEAR}
                onClick={() => {
                  setRange(RANGE_YEAR);
                  setStart(changeDate((new Date((new Date()).setUTCHours(0, 0, 0, 0))), -12, "months"));
                  setEnd(null);
                  setGrain(GRAIN_MONTHS);
                }}
                noMinWidth
              >
                Year
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_SEMESTER}
                onClick={() => {
                  setRange(RANGE_SEMESTER);
                  setStart(changeDate((new Date((new Date()).setUTCHours(0, 0, 0, 0))), -6, "months"));
                  setEnd(null);
                  setGrain(GRAIN_DAYS);
                }}
                noMinWidth
              >
                Semester
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_MONTH}
                onClick={() => {
                  setRange(RANGE_MONTH);
                  setStart(changeDate((new Date((new Date()).setUTCHours(0, 0, 0, 0))), -1, "months"));
                  setEnd(null);
                  setGrain(GRAIN_DAYS);
                }}
                noMinWidth
              >
                Month
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_WEEK}
                onClick={() => {
                  setRange(RANGE_WEEK);
                  setStart(changeDate((new Date((new Date()).setUTCHours(0, 0, 0, 0))), -7, "days"));
                  setEnd(null);
                  setGrain(GRAIN_DAYS);
                }}
                noMinWidth
              >
                Week
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_YESTERDAY}
                onClick={() => {
                  setRange(RANGE_YESTERDAY);
                  setStart(changeDate((new Date((new Date()).setUTCHours(0, 0, 0, 0))), -1, "days"));
                  setEnd(getIsoDate(new Date((new Date()).setUTCHours(0, 0, 0, 0))));
                  setGrain(GRAIN_HOURS);
                }}
                noMinWidth
              >
                Yesterday
              </OzButton>
              <OzButton
                width="100%"
                variant={"push-black"}
                pushed={range === RANGE_TODAY}
                onClick={() => {
                  setRange(RANGE_TODAY);
                  setStart(getIsoDate(new Date((new Date()).setUTCHours(0, 0, 0, 0))));
                  setEnd(null);
                  setGrain(GRAIN_HOURS);
                }}
                noMinWidth
              >
                Today
              </OzButton>
            </ButtonsGroup>
          </OzCol>
        </OzRow>
        <br/>
        {true ?
          <OzRow>
            {projects.filter(project => 
              usages.dataset.map(set => set[USAGES_UUID_COLUMN]).includes(project.uuid) &&
              selected.includes(project.uuid)
            ).length > 1 ? 
              <OzCol widthmd="4">
                <OzCard
                  height="100%"
                  headerLeft={
                    <>
                      <CardHeaderTitle title={range + " "+ (subject === SUBJECT_CREDITS ?
                          "credits"
                        : consumer === CONSUMER_STORAGE ? 
                          "storage"
                        : consumer === CONSUMER_TRANSFER ? 
                          "transfer"
                        : "assets") +" percent"} />
                    </>
                  }
                >       
                  <center> 
                    <ChartWrapper>
                      {usagesDoughnut ? 
                        <Doughnut
                          options={getChartOptions({
                            type: "doughnut", 
                            tooltipValue: (val) => subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? convertSize(val) : convertNumber(val)
                          })}
                          data={usagesDoughnut} 
                        />
                      : null }
                    </ChartWrapper>      
                  </center>
                </OzCard>
              </OzCol>
            : null}
            <OzCol widthmd={projects.filter(project => 
              usages.dataset.map(set => set[USAGES_UUID_COLUMN]).includes(project.uuid) &&
              selected.includes(project.uuid)
            ).length > 1 ? 8 : 12}>
              <OzCard
                height="100%"
                headerLeft={
                  <>
                    <CardHeaderTitle title={range + " "+(subject === SUBJECT_CREDITS ?
                        "credits"
                      : consumer === CONSUMER_STORAGE ? 
                        "storage"
                      : consumer === CONSUMER_TRANSFER ? 
                        "transfer"
                      : "assets")+" distribution by "+ GRAIN_TRANSLATIONS[grain]} />
                  </>
                }
                headerRight={
                  <CardPhrase>
                    <CardPhraseText>
                      Total {subject === SUBJECT_CREDITS ?
                          "credits"
                        : consumer === CONSUMER_STORAGE ? 
                          "storage"
                        : consumer === CONSUMER_TRANSFER ? 
                          "transfer"
                        : "assets"}
                      <CardPhraseSuperNumber>
                        {usages ? 
													subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? 
														convertSize(usages.dataset.reduce((accumulator, currentValue) => {
															return accumulator + currentValue[getColumn(subject, consumer)]
														},0))
													: 
														convertNumber(usages.dataset.reduce((accumulator, currentValue) => {
                            	return accumulator + currentValue[getColumn(subject, consumer)]
                        		},0),0)
												: null}
                      </CardPhraseSuperNumber>
                    </CardPhraseText>
                  </CardPhrase>
                }
              >       
                <center>   
                  <ChartWrapper>
                    {grain === GRAIN_HOURS && usagesBar ? 
                      <Bar options={getChartOptions({
												type: "bar", 
												yScaleLabel: (val) => subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? convertSize(val) : convertNumber(val), 
												tooltipTitle: (val) => val+":00",
												tooltipValue: (val) => subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? convertSize(val) : convertNumber(val)
											})} data={usagesBar} />
                    : grain !== GRAIN_HOURS && usagesLine ? 
                      <Line options={getChartOptions({
                        type: "line", 
                        yScaleLabel: (val) => subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? convertSize(val) : convertNumber(val), 
												tooltipValue: (val) => subject === SUBJECT_METRICS && (consumer === CONSUMER_STORAGE || consumer === CONSUMER_TRANSFER) ? convertSize(val) : convertNumber(val)
                      })} data={usagesLine} />
                    : null}
                  </ChartWrapper>    
                </center>
              </OzCard>
            </OzCol>
            <OzCol>
              <OzCard>
                <AverageWrapper>
                  <AverageLeft>
                    <AverageIcon>
                      <span className="material-symbols-outlined">monitoring</span>
                    </AverageIcon>
                    <CardHeaderTitle title="Average assets distribution from Jan 1th" />
                  </AverageLeft>
                  <AverageRight>
                    <AverageBlock>
                      <AverageLabel>Year (total)</AverageLabel>
                      <AverageValue>{averageYear ? 
                        convertNumber(parseInt(averageYear), 0)
                      : "-"}</AverageValue>
                    </AverageBlock>
                    <AverageBlock>
                      <AverageLabel>Month ({new Date().getMonth()+1})</AverageLabel>
                      <AverageValue>{averageYear ? 
                        convertNumber(
                          parseInt(averageYear / (
                            new Date().getMonth()+1
                          ) 
                        ), 0)
                      : "-"}</AverageValue>
                    </AverageBlock>
                    <AverageBlock>
                      <AverageLabel>Week ({getWeekOfYear()})</AverageLabel>
                      <AverageValue>{averageYear ? 
                        convertNumber(parseInt(averageYear / getWeekOfYear()), 0)
                      : "-"}</AverageValue>
                    </AverageBlock>
                    <AverageBlock>
                      <AverageLabel>Day ({getDayOfYear()})</AverageLabel>
                      <AverageValue>{averageYear ? 
                        convertNumber(parseInt(averageYear / getDayOfYear()), 0)
                      : "-"}</AverageValue>
                    </AverageBlock>
                  </AverageRight>
                </AverageWrapper>
              </OzCard>
            </OzCol>
            <OzCol>
            
              {usages ? 
                <OzCard
                  height="100%"
                  headerLeft={
                    <CardHeaderTitle 
                      title="Consumption of single projects"
                    />
                  }
                  headerRight={
                    <CardPhrase>
                      <CardPhraseText>
                        Number of projects
                        <CardPhraseSuperNumber>
                          {projects.filter(project => usages.dataset.map(set => set[USAGES_UUID_COLUMN]).includes(project.uuid)).length}
                        </CardPhraseSuperNumber>
                      </CardPhraseText>
                    </CardPhrase>
                  }
                >
									<Filters
										onChange={(...args) => changeFilters(...args)}
										onSearch={(...args) => searchFilters(...args)}
										fields={
											[
												{
													"label": "Search",
													"name": "search",
													"size": 4,
													"type": "text",
													"placeholder": null,
													"value": filters.search
												},{
												//   "label": "Assigned",
												//   "name": "assigned",
												//   "size": 2,
												//   "type": "select",
												//   "placeholder": null,
												//   "value": filters.assigned,
												//   "options": [
												//     {
												//       "name": <i>All</i>,
												//       "value": null
												//     },{
												//       "name": "Yes",
												//       "value": true
												//     },{
												//       "name": "No",
												//       "value": false
												//     }
												//   ]
												// },{
													"label": "Owner",
													"name": "userUuid",
													"size": 6,
													"type": "searchableselect",
													"placeholder": null,
													"value": filters.userUuid,
													"options": [{
														"name": <i>All</i>,
														"value": null,
													}].concat(filterSearchUsers.map((item) => ({
														"name": <OzUserTag
																name={item.givenName + " " + item.familyName}
																company={item.company}
																direction={"horizontal"}
															/>,
														"value": item.uuid,
													})))
												},{
													"size": 2,
													"type": "clear",
													"callback": () => {
														setFilters(DEFAULT_FILTERS);
														// localStorage.removeItem("ozwolConsoleFilterInsiderProjects"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)))
													}
												}
											]
										}
									/>
									<hr/>
                  <OzTable
                    selectable={true}
                    selected={selected}
                    onSelect={(ids) => {
                      let tempSelected = [...selected]
                      ids.forEach(id => {
                        setSelected(tempSelected);
                        if(!selected.includes(id)){
                          tempSelected.push(id);
                        }else{
                          tempSelected = tempSelected.filter(e => e !== id);
                        }                    
                      });
                      setSelected(tempSelected);
                    }}
                    columns={[
                      "Project",
                      "",
                      "Owner",
                      consumer === CONSUMER_ALL || consumer === CONSUMER_SCRIPTS ? "Assets" : null,
                      consumer === CONSUMER_ALL || consumer === CONSUMER_STORAGE ? "Storage" : null,
                      consumer === CONSUMER_ALL || consumer === CONSUMER_TRANSFER ? "Transfer" : null,
                      "Credits",
                      "Estimated revenue"
                    ]}
                    values={projects.filter(project => usages.dataset.map(set => set[USAGES_UUID_COLUMN]).includes(project.uuid)).sort((a,b) => 
                      (usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === b.uuid).reduce((accumulator, currentValue) => {
                        return accumulator + currentValue[getColumn(subject, consumer)]
                      },0))
                      -
                      (usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === a.uuid).reduce((accumulator, currentValue) => {
                        return accumulator + currentValue[getColumn(subject, consumer)]
                      },0))
                    ).map((project) => (({
                      id: project.uuid,
                      values: [
                        <ProjectTag>
                          <Color color={project.color} />
                          <OzProjectTag name={project.name} uuid={project.uuid} direction="horizontal" display="inline" />
                        </ProjectTag>,
                        <OzButton
                          size="small" 
                          noMinWidth 
                          variant="push-black"
                          onClick={() => {
                            localStorage.setItem("ozwolConsoleImpersonification"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)), project.ownerUuid);
                            navigate("/project/"+project.uuid+"/dashboard");
                          }}
                        ><ButtonIcon><span className="material-symbols-outlined">comedy_mask</span></ButtonIcon></OzButton>,
                        users.filter((user) => user.uuid === project.ownerUuid).length > 0 ? users.filter((user) => user.uuid === project.ownerUuid)[0].company : "-",
                        consumer === CONSUMER_ALL || consumer === CONSUMER_SCRIPTS ? convertNumber(usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                          return accumulator + currentValue[getColumn(SUBJECT_METRICS, CONSUMER_SCRIPTS)]
                        },0)) : null,
                        consumer === CONSUMER_ALL || consumer === CONSUMER_STORAGE ? convertSize(usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                          return accumulator + currentValue[getColumn(SUBJECT_METRICS, CONSUMER_STORAGE)]
                        },0)) : null,
                        consumer === CONSUMER_ALL || consumer === CONSUMER_TRANSFER ? convertSize(usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                          return accumulator + currentValue[getColumn(SUBJECT_METRICS, CONSUMER_TRANSFER)]
                        },0)) : null,
                        convertNumber(usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                          return accumulator + currentValue[getColumn(SUBJECT_CREDITS)]
                        },0)),
                          usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                          return accumulator + currentValue[getColumn(SUBJECT_CREDITS)]
                        },0) > 0 ? 
                          "€ "+convertNumber(
                            (
                              (
                                usages.dataset.filter(set => set[USAGES_UUID_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                                  return accumulator + currentValue[getColumn(SUBJECT_CREDITS)]
                                },0)
                              ) * (
                                users.filter(user => user.uuid === project.ownerUuid).length > 0 ? 
                                  parseFloat((
                                    users.filter(user => user.uuid === project.ownerUuid)[0].currentPlan.price
                                  /
                                    users.filter(user => user.uuid === project.ownerUuid)[0].currentPlan.credits
                                  ).toFixed(4))
                                : 0
                              )
                            ).toFixed(2)
                          ,0)
                        : "-",
                      ]
                    })))}
                  />
                </OzCard>
              : null}
            </OzCol>
          </OzRow>
        : null }
      </HealthyWrapper>
    </OzContainer>
  )
}

export default InsiderOverview;
